import axios, { type AxiosInstance, AxiosError } from 'axios';

export interface MessageResponse {
  message: string;
}

export interface ErrorResponse {
  data: MessageResponse;
  status?: number;
}

export interface TokenResponse extends MessageResponse {
  token: string;
}

const url = new URL(document.location.href);

const headers: Record<string, string> = {
  'Content-type': 'application/json',
};

if (url.searchParams.has('jwt')) {
  headers.Authorization = `Bearer ${url.searchParams.get('jwt')}`;
}

const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL ?? 'http://localhost:4000',
  headers,
  params: { UserEmail: url.searchParams.get('email') },
});

/**
 * Error Handler for axios response
 * @param err
 * @returns
 */
function errorHandler(err: AxiosError<{ message: string }>): ErrorResponse {
  // The client was given an error response (5xx, 4xx)
  if (err.response) {
    return {
      status: err.response.status,
      data: err.response.data,
    };
  }
  // Anything else
  return { data: { message: err.message } };
}

export { apiClient, errorHandler };
